/**
 * Shell controller for change password from login. Use it for any login specific functionality
 */
class ChangePasswordController {
  constructor() {

  }
}

export default ChangePasswordController;



// WEBPACK FOOTER //
// ./client/app/components/changePassword/changePassword.controller.js